const CallbackHeaderText = ({ schedulerData }) => {
    return (
        <div className="callback-header-text">
            <h2>Let's Schedule Your Free Business Insurance Consultation!</h2>
            <div>
                At Tivly, we'll connect you with a partner in our network of over 250 top-rated insurance providers. Get
                matched with the right coverage for your business and secure your policy as quickly as today. We've
                helped more than 1.4 million small businesses find the right fit—now it's your turn!
            </div>
        </div>
    );
};

export default CallbackHeaderText;
